// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file questionnaire/v1/template_service.proto (package questionnaire.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file questionnaire/v1/template_service.proto.
 */
export const file_questionnaire_v1_template_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message questionnaire.v1.ImportRequest
 */
export type ImportRequest = Message<"questionnaire.v1.ImportRequest"> & {
  /**
   * file contents as bytes
   *
   * @generated from field: bytes template = 1;
   */
  template: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message questionnaire.v1.ImportRequest.
 * Use `create(ImportRequestSchema)` to create a new message.
 */
export const ImportRequestSchema: GenMessage<ImportRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 0);

/**
 * @generated from message questionnaire.v1.ImportResponse
 */
export type ImportResponse = Message<"questionnaire.v1.ImportResponse"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: int32 question_count = 2;
   */
  questionCount: number;
};

/**
 * Describes the message questionnaire.v1.ImportResponse.
 * Use `create(ImportResponseSchema)` to create a new message.
 */
export const ImportResponseSchema: GenMessage<ImportResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 1);

/**
 * @generated from message questionnaire.v1.ListTemplatesRequest
 */
export type ListTemplatesRequest = Message<"questionnaire.v1.ListTemplatesRequest"> & {
};

/**
 * Describes the message questionnaire.v1.ListTemplatesRequest.
 * Use `create(ListTemplatesRequestSchema)` to create a new message.
 */
export const ListTemplatesRequestSchema: GenMessage<ListTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 2);

/**
 * @generated from message questionnaire.v1.ListTemplatesResponse
 */
export type ListTemplatesResponse = Message<"questionnaire.v1.ListTemplatesResponse"> & {
  /**
   * @generated from field: repeated questionnaire.v1.QuestionnaireTemplate templates = 1;
   */
  templates: QuestionnaireTemplate[];
};

/**
 * Describes the message questionnaire.v1.ListTemplatesResponse.
 * Use `create(ListTemplatesResponseSchema)` to create a new message.
 */
export const ListTemplatesResponseSchema: GenMessage<ListTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 3);

/**
 * @generated from message questionnaire.v1.QuestionnaireTemplate
 */
export type QuestionnaireTemplate = Message<"questionnaire.v1.QuestionnaireTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: int32 question_count = 4;
   */
  questionCount: number;

  /**
   * @generated from field: repeated questionnaire.v1.QuestionnaireTemplateSection sections = 5;
   */
  sections: QuestionnaireTemplateSection[];

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: bool is_default = 7;
   */
  isDefault: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message questionnaire.v1.QuestionnaireTemplate.
 * Use `create(QuestionnaireTemplateSchema)` to create a new message.
 */
export const QuestionnaireTemplateSchema: GenMessage<QuestionnaireTemplate> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 4);

/**
 * @generated from message questionnaire.v1.QuestionnaireTemplateSection
 */
export type QuestionnaireTemplateSection = Message<"questionnaire.v1.QuestionnaireTemplateSection"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 question_count = 2;
   */
  questionCount: number;
};

/**
 * Describes the message questionnaire.v1.QuestionnaireTemplateSection.
 * Use `create(QuestionnaireTemplateSectionSchema)` to create a new message.
 */
export const QuestionnaireTemplateSectionSchema: GenMessage<QuestionnaireTemplateSection> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 5);

/**
 * @generated from message questionnaire.v1.GetTemplateRequest
 */
export type GetTemplateRequest = Message<"questionnaire.v1.GetTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message questionnaire.v1.GetTemplateRequest.
 * Use `create(GetTemplateRequestSchema)` to create a new message.
 */
export const GetTemplateRequestSchema: GenMessage<GetTemplateRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 6);

/**
 * @generated from message questionnaire.v1.GetTemplateResponse
 */
export type GetTemplateResponse = Message<"questionnaire.v1.GetTemplateResponse"> & {
  /**
   * @generated from field: questionnaire.v1.QuestionnaireTemplate template = 1;
   */
  template?: QuestionnaireTemplate;
};

/**
 * Describes the message questionnaire.v1.GetTemplateResponse.
 * Use `create(GetTemplateResponseSchema)` to create a new message.
 */
export const GetTemplateResponseSchema: GenMessage<GetTemplateResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 7);

/**
 * @generated from message questionnaire.v1.DeleteTemplateRequest
 */
export type DeleteTemplateRequest = Message<"questionnaire.v1.DeleteTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message questionnaire.v1.DeleteTemplateRequest.
 * Use `create(DeleteTemplateRequestSchema)` to create a new message.
 */
export const DeleteTemplateRequestSchema: GenMessage<DeleteTemplateRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 8);

/**
 * @generated from message questionnaire.v1.DeleteTemplateResponse
 */
export type DeleteTemplateResponse = Message<"questionnaire.v1.DeleteTemplateResponse"> & {
};

/**
 * Describes the message questionnaire.v1.DeleteTemplateResponse.
 * Use `create(DeleteTemplateResponseSchema)` to create a new message.
 */
export const DeleteTemplateResponseSchema: GenMessage<DeleteTemplateResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 9);

/**
 * @generated from message questionnaire.v1.ListTemplateQuestionRequest
 */
export type ListTemplateQuestionRequest = Message<"questionnaire.v1.ListTemplateQuestionRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message questionnaire.v1.ListTemplateQuestionRequest.
 * Use `create(ListTemplateQuestionRequestSchema)` to create a new message.
 */
export const ListTemplateQuestionRequestSchema: GenMessage<ListTemplateQuestionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 10);

/**
 * @generated from message questionnaire.v1.ListTemplateQuestionResponse
 */
export type ListTemplateQuestionResponse = Message<"questionnaire.v1.ListTemplateQuestionResponse"> & {
  /**
   * @generated from field: repeated questionnaire.v1.TemplateQuestion questions = 1;
   */
  questions: TemplateQuestion[];
};

/**
 * Describes the message questionnaire.v1.ListTemplateQuestionResponse.
 * Use `create(ListTemplateQuestionResponseSchema)` to create a new message.
 */
export const ListTemplateQuestionResponseSchema: GenMessage<ListTemplateQuestionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 11);

/**
 * @generated from message questionnaire.v1.TemplateQuestion
 */
export type TemplateQuestion = Message<"questionnaire.v1.TemplateQuestion"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string section = 2;
   */
  section: string;

  /**
   * @generated from field: string sub_section = 3;
   */
  subSection: string;

  /**
   * @generated from field: string question = 4;
   */
  question: string;

  /**
   * @generated from field: string note = 5;
   */
  note: string;

  /**
   * @generated from field: bool leading_question = 6;
   */
  leadingQuestion: boolean;

  /**
   * @generated from field: questionnaire.v1.QuestionType type = 7;
   */
  type: QuestionType;

  /**
   * @generated from field: repeated questionnaire.v1.TemplateOption options = 8;
   */
  options: TemplateOption[];

  /**
   * @generated from field: int32 display_order = 9;
   */
  displayOrder: number;
};

/**
 * Describes the message questionnaire.v1.TemplateQuestion.
 * Use `create(TemplateQuestionSchema)` to create a new message.
 */
export const TemplateQuestionSchema: GenMessage<TemplateQuestion> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 12);

/**
 * @generated from message questionnaire.v1.TemplateOption
 */
export type TemplateOption = Message<"questionnaire.v1.TemplateOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool is_flag = 2;
   */
  isFlag: boolean;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: bool needs_explanation = 4;
   */
  needsExplanation: boolean;
};

/**
 * Describes the message questionnaire.v1.TemplateOption.
 * Use `create(TemplateOptionSchema)` to create a new message.
 */
export const TemplateOptionSchema: GenMessage<TemplateOption> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 13);

/**
 * @generated from message questionnaire.v1.UpdateTemplateRequest
 */
export type UpdateTemplateRequest = Message<"questionnaire.v1.UpdateTemplateRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional bool is_default = 4;
   */
  isDefault?: boolean;
};

/**
 * Describes the message questionnaire.v1.UpdateTemplateRequest.
 * Use `create(UpdateTemplateRequestSchema)` to create a new message.
 */
export const UpdateTemplateRequestSchema: GenMessage<UpdateTemplateRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 14);

/**
 * @generated from message questionnaire.v1.UpdateTemplateResponse
 */
export type UpdateTemplateResponse = Message<"questionnaire.v1.UpdateTemplateResponse"> & {
};

/**
 * Describes the message questionnaire.v1.UpdateTemplateResponse.
 * Use `create(UpdateTemplateResponseSchema)` to create a new message.
 */
export const UpdateTemplateResponseSchema: GenMessage<UpdateTemplateResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 15);

/**
 * @generated from message questionnaire.v1.RenameSectionRequest
 */
export type RenameSectionRequest = Message<"questionnaire.v1.RenameSectionRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string current_name = 2;
   */
  currentName: string;

  /**
   * @generated from field: string new_name = 3;
   */
  newName: string;
};

/**
 * Describes the message questionnaire.v1.RenameSectionRequest.
 * Use `create(RenameSectionRequestSchema)` to create a new message.
 */
export const RenameSectionRequestSchema: GenMessage<RenameSectionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 16);

/**
 * @generated from message questionnaire.v1.RenameSectionResponse
 */
export type RenameSectionResponse = Message<"questionnaire.v1.RenameSectionResponse"> & {
};

/**
 * Describes the message questionnaire.v1.RenameSectionResponse.
 * Use `create(RenameSectionResponseSchema)` to create a new message.
 */
export const RenameSectionResponseSchema: GenMessage<RenameSectionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 17);

/**
 * @generated from message questionnaire.v1.UpdateQuestionRequest
 */
export type UpdateQuestionRequest = Message<"questionnaire.v1.UpdateQuestionRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: int32 question_id = 2;
   */
  questionId: number;

  /**
   * @generated from field: optional bool leading_question = 3;
   */
  leadingQuestion?: boolean;

  /**
   * @generated from field: optional questionnaire.v1.QuestionType type = 4;
   */
  type?: QuestionType;

  /**
   * @generated from field: optional string question = 5;
   */
  question?: string;

  /**
   * @generated from field: optional string note = 6;
   */
  note?: string;

  /**
   * @generated from field: optional string sub_section = 7;
   */
  subSection?: string;

  /**
   * @generated from field: optional int32 display_order = 8;
   */
  displayOrder?: number;
};

/**
 * Describes the message questionnaire.v1.UpdateQuestionRequest.
 * Use `create(UpdateQuestionRequestSchema)` to create a new message.
 */
export const UpdateQuestionRequestSchema: GenMessage<UpdateQuestionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 18);

/**
 * @generated from message questionnaire.v1.UpdateQuestionResponse
 */
export type UpdateQuestionResponse = Message<"questionnaire.v1.UpdateQuestionResponse"> & {
};

/**
 * Describes the message questionnaire.v1.UpdateQuestionResponse.
 * Use `create(UpdateQuestionResponseSchema)` to create a new message.
 */
export const UpdateQuestionResponseSchema: GenMessage<UpdateQuestionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 19);

/**
 * @generated from message questionnaire.v1.DeleteQuestionRequest
 */
export type DeleteQuestionRequest = Message<"questionnaire.v1.DeleteQuestionRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: int32 question_id = 2;
   */
  questionId: number;
};

/**
 * Describes the message questionnaire.v1.DeleteQuestionRequest.
 * Use `create(DeleteQuestionRequestSchema)` to create a new message.
 */
export const DeleteQuestionRequestSchema: GenMessage<DeleteQuestionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 20);

/**
 * @generated from message questionnaire.v1.DeleteQuestionResponse
 */
export type DeleteQuestionResponse = Message<"questionnaire.v1.DeleteQuestionResponse"> & {
};

/**
 * Describes the message questionnaire.v1.DeleteQuestionResponse.
 * Use `create(DeleteQuestionResponseSchema)` to create a new message.
 */
export const DeleteQuestionResponseSchema: GenMessage<DeleteQuestionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 21);

/**
 * @generated from message questionnaire.v1.AddQuestionRequest
 */
export type AddQuestionRequest = Message<"questionnaire.v1.AddQuestionRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string section = 2;
   */
  section: string;

  /**
   * @generated from field: string sub_section = 3;
   */
  subSection: string;

  /**
   * @generated from field: string question = 4;
   */
  question: string;

  /**
   * @generated from field: questionnaire.v1.QuestionType type = 5;
   */
  type: QuestionType;

  /**
   * @generated from field: optional string note = 6;
   */
  note?: string;

  /**
   * @generated from field: repeated questionnaire.v1.TemplateOption options = 7;
   */
  options: TemplateOption[];

  /**
   * @generated from field: int32 display_order = 8;
   */
  displayOrder: number;
};

/**
 * Describes the message questionnaire.v1.AddQuestionRequest.
 * Use `create(AddQuestionRequestSchema)` to create a new message.
 */
export const AddQuestionRequestSchema: GenMessage<AddQuestionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 22);

/**
 * @generated from message questionnaire.v1.AddQuestionResponse
 */
export type AddQuestionResponse = Message<"questionnaire.v1.AddQuestionResponse"> & {
  /**
   * @generated from field: int32 question_id = 1;
   */
  questionId: number;
};

/**
 * Describes the message questionnaire.v1.AddQuestionResponse.
 * Use `create(AddQuestionResponseSchema)` to create a new message.
 */
export const AddQuestionResponseSchema: GenMessage<AddQuestionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 23);

/**
 * @generated from message questionnaire.v1.UpdateOptionRequest
 */
export type UpdateOptionRequest = Message<"questionnaire.v1.UpdateOptionRequest"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: int32 question_id = 2;
   */
  questionId: number;

  /**
   * @generated from field: string option_id = 3;
   */
  optionId: string;

  /**
   * @generated from field: optional bool is_flag = 4;
   */
  isFlag?: boolean;

  /**
   * @generated from field: optional string label = 5;
   */
  label?: string;

  /**
   * @generated from field: optional bool needs_explanation = 6;
   */
  needsExplanation?: boolean;
};

/**
 * Describes the message questionnaire.v1.UpdateOptionRequest.
 * Use `create(UpdateOptionRequestSchema)` to create a new message.
 */
export const UpdateOptionRequestSchema: GenMessage<UpdateOptionRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 24);

/**
 * @generated from message questionnaire.v1.UpdateOptionResponse
 */
export type UpdateOptionResponse = Message<"questionnaire.v1.UpdateOptionResponse"> & {
};

/**
 * Describes the message questionnaire.v1.UpdateOptionResponse.
 * Use `create(UpdateOptionResponseSchema)` to create a new message.
 */
export const UpdateOptionResponseSchema: GenMessage<UpdateOptionResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 25);

/**
 * @generated from message questionnaire.v1.CreateBlankTemplateRequest
 */
export type CreateBlankTemplateRequest = Message<"questionnaire.v1.CreateBlankTemplateRequest"> & {
  /**
   * Required: Initial name for the template
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional: Initial description
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;
};

/**
 * Describes the message questionnaire.v1.CreateBlankTemplateRequest.
 * Use `create(CreateBlankTemplateRequestSchema)` to create a new message.
 */
export const CreateBlankTemplateRequestSchema: GenMessage<CreateBlankTemplateRequest> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 26);

/**
 * @generated from message questionnaire.v1.CreateBlankTemplateResponse
 */
export type CreateBlankTemplateResponse = Message<"questionnaire.v1.CreateBlankTemplateResponse"> & {
  /**
   * The ID of the newly created template
   *
   * @generated from field: string template_id = 1;
   */
  templateId: string;
};

/**
 * Describes the message questionnaire.v1.CreateBlankTemplateResponse.
 * Use `create(CreateBlankTemplateResponseSchema)` to create a new message.
 */
export const CreateBlankTemplateResponseSchema: GenMessage<CreateBlankTemplateResponse> = /*@__PURE__*/
  messageDesc(file_questionnaire_v1_template_service, 27);

/**
 * @generated from enum questionnaire.v1.QuestionType
 */
export enum QuestionType {
  /**
   * @generated from enum value: QUESTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUESTION_TYPE_RADIO = 1;
   */
  RADIO = 1,

  /**
   * @generated from enum value: QUESTION_TYPE_CHECKBOX = 2;
   */
  CHECKBOX = 2,

  /**
   * @generated from enum value: QUESTION_TYPE_FREE_TEXT = 3;
   */
  FREE_TEXT = 3,

  /**
   * @generated from enum value: QUESTION_TYPE_FILE = 4;
   */
  FILE = 4,

  /**
   * @generated from enum value: QUESTION_TYPE_DATE = 5;
   */
  DATE = 5,
}

/**
 * Describes the enum questionnaire.v1.QuestionType.
 */
export const QuestionTypeSchema: GenEnum<QuestionType> = /*@__PURE__*/
  enumDesc(file_questionnaire_v1_template_service, 0);

/**
 * @generated from service questionnaire.v1.TemplateService
 */
export const TemplateService: GenService<{
  /**
   * @generated from rpc questionnaire.v1.TemplateService.Import
   */
  import: {
    methodKind: "unary";
    input: typeof ImportRequestSchema;
    output: typeof ImportResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.ListTemplates
   */
  listTemplates: {
    methodKind: "unary";
    input: typeof ListTemplatesRequestSchema;
    output: typeof ListTemplatesResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.GetTemplate
   */
  getTemplate: {
    methodKind: "unary";
    input: typeof GetTemplateRequestSchema;
    output: typeof GetTemplateResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.DeleteTemplate
   */
  deleteTemplate: {
    methodKind: "unary";
    input: typeof DeleteTemplateRequestSchema;
    output: typeof DeleteTemplateResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.ListTemplateQuestion
   */
  listTemplateQuestion: {
    methodKind: "unary";
    input: typeof ListTemplateQuestionRequestSchema;
    output: typeof ListTemplateQuestionResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.UpdateTemplate
   */
  updateTemplate: {
    methodKind: "unary";
    input: typeof UpdateTemplateRequestSchema;
    output: typeof UpdateTemplateResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.RenameSection
   */
  renameSection: {
    methodKind: "unary";
    input: typeof RenameSectionRequestSchema;
    output: typeof RenameSectionResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.UpdateQuestion
   */
  updateQuestion: {
    methodKind: "unary";
    input: typeof UpdateQuestionRequestSchema;
    output: typeof UpdateQuestionResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.DeleteQuestion
   */
  deleteQuestion: {
    methodKind: "unary";
    input: typeof DeleteQuestionRequestSchema;
    output: typeof DeleteQuestionResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.AddQuestion
   */
  addQuestion: {
    methodKind: "unary";
    input: typeof AddQuestionRequestSchema;
    output: typeof AddQuestionResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.UpdateOption
   */
  updateOption: {
    methodKind: "unary";
    input: typeof UpdateOptionRequestSchema;
    output: typeof UpdateOptionResponseSchema;
  },
  /**
   * @generated from rpc questionnaire.v1.TemplateService.CreateBlankTemplate
   */
  createBlankTemplate: {
    methodKind: "unary";
    input: typeof CreateBlankTemplateRequestSchema;
    output: typeof CreateBlankTemplateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_questionnaire_v1_template_service, 0);

